var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13363",
    "data-name": "Group 13363",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 679.398,
    height: 416.446,
    viewBox: "0 0 679.398 416.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    width: 679.398,
    height: 416.446,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24892",
    "data-name": "Path 24892",
    d: "M189.979,180c-13.439,14.29-2.211,35.575,30.115,47.144s123.623,15.126,123.623,15.126a40.464,40.464,0,0,0,2.777-20.936s-62.62-21.6-85.833-30.1c-16.781-6.15-39.214-16.744-55.436-16.746-6.218,0-11.521,1.556-15.246,5.517",
    transform: "translate(-184.413 -174.482)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13358",
    "data-name": "Group 13358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13357",
    "data-name": "Group 13357",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24837",
    "data-name": "Path 24837",
    d: "M310.578,65.272s21.647-26.116,63.149-9.475,82.12,84.977,44.371,167.648",
    transform: "translate(179.937 29.114)",
    fill: "none",
    stroke: "#274d79",
    strokeMiterlimit: 10,
    strokeWidth: 0.782
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24838",
    "data-name": "Path 24838",
    d: "M320.221,78.842c-1.9,4.879-20.767-2.464-18.869-7.342L304,64.707a10.123,10.123,0,0,1,18.869,7.342Z",
    transform: "translate(174.514 33.749)",
    fill: "#03aa99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24839",
    "data-name": "Path 24839",
    d: "M301.365,66.978c-2.153,4.771,16.97,12.221,18.869,7.342,1.442-3.768-17.318-10.779-18.869-7.342",
    transform: "translate(174.501 38.271)",
    fill: "#3b55ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24840",
    "data-name": "Path 24840",
    d: "M307.242,69.616c-.205.61-1.109.854-2.017.548s-1.478-1.049-1.273-1.658,1.109-.856,2.017-.55,1.478,1.05,1.273,1.66",
    transform: "translate(176.074 39.295)",
    fill: "#000e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24841",
    "data-name": "Path 24841",
    d: "M311.482,71.181c-.205.61-1.109.854-2.017.548s-1.478-1.049-1.273-1.658,1.109-.856,2.018-.55,1.477,1.05,1.271,1.66",
    transform: "translate(178.53 40.202)",
    fill: "#000e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24842",
    "data-name": "Path 24842",
    d: "M382.67,262.961a27.176,27.176,0,0,1-13.48-9.71c-5.321-7.464-2.483-25.29,6.739-30.388s16.318-11.13,14.9-24.963,3.192-24.831,14.9-26.251,16.318-1.592,28.024-12.147,21.283-12.226,25.9-6.246,1.065,14.058-1.418,21.192,6.384,14.415,8.159,21.595.354,16.441-8.87,21.565-15.607,9.228-14.543,18.527-4.258,23.425-24.122,26.827Z",
    transform: "translate(212.349 86.8)",
    fill: "#3dc19a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24843",
    "data-name": "Path 24843",
    d: "M434.714,161.448s-43.211,33.907-50.871,94.774",
    transform: "translate(222.384 93.537)",
    fill: "none",
    stroke: "#3b55ce",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24844",
    "data-name": "Path 24844",
    d: "M357.18,146.212c-6.809,4.278-6.385,11.7-6.03,21.111s-2.345,12.839-7.736,19.109-2.483,15.847,6.883,20.1,17.525,10.836,12.559,21.912-3.193,31.235,21.283,37.829l31.474.071s22.09-12.864,24.929-36.338-15.963-25.548-21.283-33.38-3.742-18.5-3.645-29.307-8.061-16.274-19.058-15.667-15.29-.013-20.966-3.9-12.733-5.114-18.409-1.548",
    transform: "translate(197.4 83.484)",
    fill: "#91dbac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24845",
    "data-name": "Path 24845",
    d: "M358.071,154.258c.066.311,38.28,26.281,36.407,106.01",
    transform: "translate(207.452 89.371)",
    fill: "none",
    stroke: "#3b55ce",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.575
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24846",
    "data-name": "Path 24846",
    d: "M653.88,226.2H2.486a2.488,2.488,0,0,1,0-4.975H653.88a2.488,2.488,0,0,1,0,4.975",
    transform: "translate(0 128.17)",
    fill: "#638be2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24847",
    "data-name": "Path 24847",
    d: "M523.2,286.451H120.376a49.965,49.965,0,0,1-49.965-49.966V224.376H573.167v12.109A49.965,49.965,0,0,1,523.2,286.451",
    transform: "translate(40.793 129.995)",
    fill: "#e5f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24848",
    "data-name": "Path 24848",
    d: "M207,218.526c5.319,4.285,20.51,21.482,78.534,21.482,16.185,0,33.667.678,47.866-3.178,36.708-9.966,60.739-23.316,60.739-23.316l-71-24.159-63.647.363Z",
    transform: "translate(119.93 109.705)",
    fill: "#1e4174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24849",
    "data-name": "Path 24849",
    d: "M248.115,201.407l-27.764,5.286,1,15.118,31.118-.766Z",
    transform: "translate(127.663 116.687)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24850",
    "data-name": "Path 24850",
    d: "M237.931,215.339s67.3-19.033,88.225-24.351c23.961-6.09,60.308-22.62,72.562-7.3s-2.694,35.727-35.842,44.674-123.853,8.066-123.853,8.066Z",
    transform: "translate(137.848 102.755)",
    fill: "#1e4174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24851",
    "data-name": "Path 24851",
    d: "M204.156,198.9s-1.088,3.475-.914,10.836,3.9,12.948,4.282,23.687c0,0,4.171-6.859,3.967-17.989s-7.335-16.534-7.335-16.534",
    transform: "translate(117.739 115.235)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24852",
    "data-name": "Path 24852",
    d: "M241.747,223.4c-4.348.464-11.616,3.858-16.076,6.22s-6.84,4.831-14.8,4.774c0,0-.032-21.032-.884-27.538s-2.164-7.622-2.164-7.622,7.369.471,11.033,2.434,4.075,2.863,10.541,3.116,9.111.6,11.934.546c4.288,6.708,2.582,14.854.412,18.069",
    transform: "translate(120.407 115.431)",
    fill: "#8c64aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24853",
    "data-name": "Path 24853",
    d: "M217.81,222.862s2.469-10.921-1.147-18.392",
    transform: "translate(125.526 118.462)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24854",
    "data-name": "Path 24854",
    d: "M220.69,221.269s2.4-8.3-1.123-16.248",
    transform: "translate(127.208 118.781)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24855",
    "data-name": "Path 24855",
    d: "M223.788,219.046s2.168-5.547-.712-13.744",
    transform: "translate(129.241 118.944)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24856",
    "data-name": "Path 24856",
    d: "M213.22,234.831c-2.518-.046-5.594-.118-6.021-1.172s2.518-7.331,1.347-19.77c-.63-6.684-5.318-14.532-4.713-14.753s4.286-1.6,6.338.535,12.444,15.781,3.048,35.16",
    transform: "translate(118.062 114.999)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24857",
    "data-name": "Path 24857",
    d: "M315.361,152.337c8.753-6.191,27.615-20.595,37.537-51.528a62.023,62.023,0,0,0,3.345-21.056c-5.116-4.312-4.579-12.456-9.249-17.515-6.564-7.11-12.445-16.135.395-16.135,7.158,0,13.747.291,17.269,3.7,2.792,2.7,8.072,10.7,9.04,13.478,2.187,6.292-.352,14.216-.625,23.79s-6.565,69.471-52.789,94.634Z",
    transform: "translate(182.708 26.71)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24858",
    "data-name": "Path 24858",
    d: "M255.8,99.511a91.416,91.416,0,0,1-.873,10.831c-.668,3.167,0,4.833-9.666,6.5,0,0,3.926,12.663,20.674,14.83s23.578-11,23.079-11a35.188,35.188,0,0,1-6.667-2.889c-1.5-.971-.392-19.439-.392-19.439Z",
    transform: "translate(142.093 56.977)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24859",
    "data-name": "Path 24859",
    d: "M277.948,103.018s-2.047,6.49-12.21,7.156-13.952-5.743-13.952-5.743l.231-4.921,26.157-1.166Z",
    transform: "translate(145.875 56.977)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24860",
    "data-name": "Path 24860",
    d: "M244.879,81.49s-5.253-.823-7.562,3.042.578,11.086,6.047,12.289c5.24,1.153,6.962-1.785,6.962-1.785Z",
    transform: "translate(137.028 47.17)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24861",
    "data-name": "Path 24861",
    d: "M239.645,84.11a4.84,4.84,0,0,1,4.294-.095c.437.267-.153,1.012-.551.922-2.254-.509-4.9-.267-5.618,2.386-.038.141-.152.014-.145-.079a3.538,3.538,0,0,1,2.02-3.135",
    transform: "translate(137.67 48.408)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24862",
    "data-name": "Path 24862",
    d: "M240.116,83.956c.223-.145.845.377.818.548a2.93,2.93,0,0,0-1.033,1.188,3.9,3.9,0,0,0-.183,2.5,4.377,4.377,0,0,0,4.024,3.7c.038,0,.115.1.055.128-1.758.7-4.068-.9-4.7-2.476-.7-1.74-.925-4.316,1.023-5.583",
    transform: "translate(138.227 48.626)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24863",
    "data-name": "Path 24863",
    d: "M274,75.724s4.582-2.712,8.157.022,3.571,10.511-1.065,13.655c-4.44,3.013-7.128.921-7.128.921Z",
    transform: "translate(158.724 43.177)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24864",
    "data-name": "Path 24864",
    d: "M279.1,76.483a4.835,4.835,0,0,0-4.024,1.5c-.308.409.516.881.854.651,1.9-1.306,4.449-2.061,6.1.136.088.118.147-.043.107-.126a3.54,3.54,0,0,0-3.039-2.164",
    transform: "translate(159.327 44.3)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24865",
    "data-name": "Path 24865",
    d: "M277.215,76.756c-.261-.052-.646.663-.556.812a2.926,2.926,0,0,1,1.4.722,3.9,3.9,0,0,1,1.095,2.252,4.377,4.377,0,0,1-2.367,4.924c-.035.019-.07.139-.006.139,1.892,0,3.445-2.347,3.454-4.042.011-1.878-.739-4.353-3.018-4.808",
    transform: "translate(160.278 44.468)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24866",
    "data-name": "Path 24866",
    d: "M274.337,59.689a24.623,24.623,0,0,0-12.611-1.038,25.184,25.184,0,0,0-11.575,5.474c-7.633,6.559-10.579,16.934-8.72,26.658l.008.041a72.3,72.3,0,0,0,2.08,8.23l1.194,3.775a59.2,59.2,0,0,0,6.412,13.766,22.664,22.664,0,0,0,41.91-8.047,59.237,59.237,0,0,0,.858-15.163l-.289-3.948a72.282,72.282,0,0,0-1.117-8.415.274.274,0,0,0-.008-.041,27.948,27.948,0,0,0-18.142-21.291",
    transform: "translate(139.563 33.749)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24867",
    "data-name": "Path 24867",
    d: "M264.465,78.77a2.721,2.721,0,1,1,3.186,2.159,2.72,2.72,0,0,1-3.186-2.159",
    transform: "translate(153.192 43.762)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24868",
    "data-name": "Path 24868",
    d: "M264.866,72.622l12.816,2.429s-.911-3.52-5.469-5.364a6.924,6.924,0,0,0-5.591.022,3.085,3.085,0,0,0-1.756,2.912",
    transform: "translate(153.449 40.042)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24869",
    "data-name": "Path 24869",
    d: "M254.462,74.354l-9.374,9.073s-1.175-3.443,1.62-7.488a6.922,6.922,0,0,1,4.686-3.053,3.088,3.088,0,0,1,3.067,1.467",
    transform: "translate(141.853 42.22)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24870",
    "data-name": "Path 24870",
    d: "M255.6,80.71a2.722,2.722,0,1,0-2.159,3.187A2.72,2.72,0,0,0,255.6,80.71",
    transform: "translate(144.961 45.481)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24871",
    "data-name": "Path 24871",
    d: "M260.115,78.209c-1.235.33-2.135,12.97-.423,14.769a3.955,3.955,0,0,0,6.287-1.207c.925-2.306-4.593-13.714-5.864-13.562",
    transform: "translate(149.907 45.31)",
    fill: "#ba5964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24872",
    "data-name": "Path 24872",
    d: "M232.69,63.941s9.724-1.9,13.426,3.094",
    transform: "translate(134.811 36.84)",
    fill: "none",
    stroke: "#001c45",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.715
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24873",
    "data-name": "Path 24873",
    d: "M232.512,57.751s12.065,2.031,13.881,13.567",
    transform: "translate(134.708 33.459)",
    fill: "none",
    stroke: "#001c45",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.715
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24874",
    "data-name": "Path 24874",
    d: "M248.743,75.2s6.8,10.241,17.984,13.267,17.5-9.915,16.368-15.8c0,0,10.931,17.6,13.39,17.545a36.493,36.493,0,0,0,1.794-15.026,19.36,19.36,0,0,0-8.675-14.8,7.915,7.915,0,0,0-9.163-.1c-2.033-3.832-8.025-11.937-19.823-10.615-13.2,1.478-18.327,10.591-16.4,24.5,0,0-4.954-1.4-7.92,4.353s.335,16.923,4.282,22.22c0,0,3.44-1.087,5.092-.771,0,0-2.317-9.2-.141-17.266,1.769-6.564,3.216-7.5,3.216-7.5",
    transform: "translate(136.238 28.691)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24875",
    "data-name": "Path 24875",
    d: "M262.369,109.5c1.183,4.771,7.93,12.335,17.736,12.793s17.9-6.126,19.24-9.026c8.187.758,18.584,2.98,22.076,3.615,4.947.9,9.74,5.31,7.973,19.229-1.717,13.516-12.439,98.955-12.439,98.955s-28.348,11-66.662.916c0,0-23.185-92.735-25.248-100.758s-4.585-16.5,2.75-19.023,34.574-6.7,34.574-6.7",
    transform: "translate(129.137 63.441)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24876",
    "data-name": "Path 24876",
    d: "M287.673,181.25c.54.1,1.087.186,1.635.243,5.4.565,2.945-5.539,1.248-7.944-2.593-3.672-20.562-17.6-20.562-17.6l-13.963,1.178L240.3,163.61l-6.464,5.019c1.306,5.22,2.574,10.288,3.746,14.974,5.88-3.685,20.1-12.415,23.254-12.708a11.25,11.25,0,0,1,5.533,1.267c2.56,1.1,5.128,2.105,7.747,3.061a37.84,37.84,0,0,1,3.516,1.418c2.056,1,3.92,2.36,6,3.315a17.8,17.8,0,0,0,4.043,1.293",
    transform: "translate(135.476 90.351)",
    fill: "#8c64aa"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x2: 10.176,
    y2: 4.853,
    transform: "translate(483.492 242.365)",
    fill: "none",
    stroke: "#274d79",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x2: 10.176,
    y2: 4.853,
    transform: "translate(479.189 250.806)",
    fill: "none",
    stroke: "#274d79",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24877",
    "data-name": "Path 24877",
    d: "M213.454,200.189c13.38,1.954,37.093,2.431,58.048-16.53,16.875-15.269,32.268-44.418,71.453-31.6",
    transform: "translate(123.667 86.257)",
    fill: "none",
    stroke: "#274d79",
    strokeMiterlimit: 10,
    strokeWidth: 0.782
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24878",
    "data-name": "Path 24878",
    d: "M314.941,151.655c4.628,2.448-4.842,20.344-9.47,17.9l-6.442-3.41a10.123,10.123,0,1,1,9.468-17.9Z",
    transform: "translate(170.122 85.205)",
    fill: "#03aa99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24879",
    "data-name": "Path 24879",
    d: "M234.784,122.621s-31.7,57.3-37.467,66.966-4.577,20.513-3.391,23.226,17.632,4.577,32.721-1.188,53.937-25.5,56.819-27.028a70.359,70.359,0,0,0,7.4,4.188c5.184,2.456,9.381,2.555,12.741,5.1s7.046,7.39,13.537,4.256c3.865-1.865-4.707-13.889-8.544-20.525-3.753-3.211-17.152-8.759-23.87-7.8-9.5,1.352-57.214,17.593-57.214,17.593L244.8,157.574Z",
    transform: "translate(111.785 71.042)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24880",
    "data-name": "Path 24880",
    d: "M240.274,113.408c-7.783,2.446-10.784,6.261-18.4,20.108s-17.686,30.695-17.686,30.695,8.183,12.756,26.225,16.386l12.245-20.686Z",
    transform: "translate(118.299 65.704)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24881",
    "data-name": "Path 24881",
    d: "M285.279,114.643c9.313,1.519,33.015,8.472,47.51-1.276,0,0,9.573,14.6,7.932,32.922,0,0-19.649,17.517-50.356,10.49Z",
    transform: "translate(165.279 65.68)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24882",
    "data-name": "Path 24882",
    d: "M289.206,204.146l27.252,7.491-2.211,14.99-30.955-3.253Z",
    transform: "translate(164.128 118.274)",
    fill: "#ff9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24883",
    "data-name": "Path 24883",
    d: "M346.493,221.332s-62.619-21.6-85.832-30.1S203.42,165.707,189.98,180s-2.213,35.575,30.114,47.144,123.624,15.126,123.624,15.126a40.464,40.464,0,0,0,2.775-20.936",
    transform: "translate(106.842 101.088)",
    fill: "#85b8ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24884",
    "data-name": "Path 24884",
    d: "M324.489,204.377s.806,3.55.043,10.875-4.924,12.594-6.163,23.267c0,0-3.609-7.17-2.516-18.248s8.636-15.895,8.636-15.895",
    transform: "translate(182.873 118.408)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24885",
    "data-name": "Path 24885",
    d: "M295.172,225.768c4.3.81,11.272,4.776,15.528,7.486s6.431,5.364,14.364,5.943c0,0,1.715-20.963,3.084-27.38s2.769-7.423,2.769-7.423-7.383-.122-11.194,1.543-4.291,2.529-10.755,2.262-9.13-.131-11.938-.409c-4.812,6.343-3.762,14.6-1.857,17.978",
    transform: "translate(170.084 118.417)",
    fill: "#8c64aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24886",
    "data-name": "Path 24886",
    d: "M306.444,227.141s-1.587-11.084,2.614-18.24",
    transform: "translate(177.371 121.029)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24887",
    "data-name": "Path 24887",
    d: "M303.652,225.324s-1.725-8.465,2.42-16.106",
    transform: "translate(175.718 121.213)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24888",
    "data-name": "Path 24888",
    d: "M300.541,222.859s-1.718-5.7,1.808-13.643",
    transform: "translate(173.879 121.212)",
    fill: "none",
    stroke: "#9d7eb4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24889",
    "data-name": "Path 24889",
    d: "M314.5,239.543c2.513.156,5.585.33,6.095-.687s-1.922-7.51.24-19.815c1.161-6.613,6.463-14.059,5.877-14.328s-4.144-1.939-6.36.027-13.666,14.735-5.852,34.8",
    transform: "translate(180.648 118.071)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24890",
    "data-name": "Path 24890",
    d: "M346.407,226.669H345s-40.815-2.65-84.526-9.858c-42.937-7.08-71.964-21.519-75.86-32.14-1.909,12.845,10.459,27.615,35.476,36.569,32.326,11.57,123.624,15.126,123.624,15.126a41.263,41.263,0,0,0,2.694-9.7",
    transform: "translate(106.846 106.991)",
    fill: "#4e7eac"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13360",
    "data-name": "Group 13360",
    transform: "translate(291.255 275.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13359",
    "data-name": "Group 13359",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24891",
    "data-name": "Path 24891",
    d: "M283.261,201.823c-.054,5.651-1.213,18.346-3.7,26.149",
    transform: "translate(-129.29 -158.642)",
    fill: "none",
    stroke: "#274d79",
    strokeMiterlimit: 10,
    strokeWidth: 0.782
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13362",
    "data-name": "Group 13362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13361",
    "data-name": "Group 13361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24893",
    "data-name": "Path 24893",
    d: "M228.547,154.573s4.869-12.908,1.54-31.952c0,0,6.1,23.232-.518,36.033Z",
    transform: "translate(132.411 71.042)",
    fill: "#8c64aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24894",
    "data-name": "Path 24894",
    d: "M289.015,151.258s1.778-14.68-1.407-28.365c0,0,3.871,7.873,3.669,28.842Z",
    transform: "translate(166.629 71.199)",
    fill: "#8c64aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24895",
    "data-name": "Path 24895",
    d: "M166.387,188.829c5.668-1.142,15.6-2.142,22.651,4.024,4.509,3.942,2.374,4.626-1.65,4.555-6.779-.122-12.18,5.569-12.18,5.569s-8.816,1.006-10.981-6c-3.137-10.149,2.161-8.15,2.161-8.15",
    transform: "translate(94.571 108.905)",
    fill: "#e09b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24896",
    "data-name": "Path 24896",
    d: "M204.186,250.352h43.537c9.94.226,16.719-.539,21.6-4.858,5.665-5.016,6.651-13.962,5.747-20.806-1.057-2.753-7.074-.714-14.492-1.968-6.731-1.137-10.624-4.173-14.473-9.3-3.822-5.1-5.875-7.145-13.44-10.828a16.608,16.608,0,0,0-7.524-1.823,34.824,34.824,0,0,1,6.722-9.582c4.893-4.525-3.831-6.324-13.778-1.853-5.905,2.655-12.092,7.841-16.438,12.79-2.819,3.208-10.195,2.726-18.183-3.41s-36.011-31.611-66.695-27.326-51.989,29.409-55.117,47.472,2.895,28.324,8.105,31.53Z",
    transform: "translate(35.219 99.013)",
    fill: "#faba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24897",
    "data-name": "Path 24897",
    d: "M86.237,202.427C77.7,197.794,55.858,197.5,39.409,210.6,23.371,223.382,16.69,250.048,29.9,270.167s39.359,20.751,42.733,17.905S58.695,274.956,54,261.838c0,0,9.361,5.959,14.7,6.521s-8.153-13.224-9.558-27.838,5.807-30.649,23.567-29.94Z",
    transform: "translate(13.252 115.595)",
    fill: "#faba50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24898",
    "data-name": "Path 24898",
    d: "M198.936,215.443c-.956.185-.6-5.092-1.761-4.586s.717,3.206.717,3.206c-3.295-.812-7.941-5.537-6.087-8.464,1.908-3.013,7.256-1.643,8.51-1.118,1.909.8,3.227,7.159-1.379,10.962",
    transform: "translate(110.879 118.022)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24899",
    "data-name": "Path 24899",
    d: "M92.9,185.846a20.114,20.114,0,0,1,16.277,13.695c4.506,12.725-.5,20.371-4.215,24.478,0,0,16.7-1.59,24.125,3.315s6.76,14.448,6.76,14.448l4.04.022s.177-11.681-7.644-16.586-14.423-5.517-18.8-5.213a27.635,27.635,0,0,0-.662-21.566c-5.255-11.651-15.244-13.256-19.883-12.592",
    transform: "translate(53.823 107.598)",
    fill: "#e09b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24900",
    "data-name": "Path 24900",
    d: "M131.8,210.136s17.382-1.932,24.745,3.621,6.491,14.811,6.491,14.811l4.128.035s1.087-9.895-6.4-15.931-24.02-4.226-28.969-2.536",
    transform: "translate(76.363 120.797)",
    fill: "#e09b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24901",
    "data-name": "Path 24901",
    d: "M163.46,206.542s-.722-4.334,4.4-5.471c5.529-1.227,7.011,2.908,7.011,2.908a11.8,11.8,0,0,0-6.482-.172,12.777,12.777,0,0,0-4.929,2.735",
    transform: "translate(94.682 116.361)",
    fill: "#001c45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24902",
    "data-name": "Path 24902",
    d: "M182.133,22.175l33.55,34.759L204.446,69.61,167.252,38.962ZM226.72,65.74a9.108,9.108,0,0,1,2.293,3.072,10.054,10.054,0,0,1,.9,3.579,9.735,9.735,0,0,1-.479,3.645,9.183,9.183,0,0,1-1.892,3.276,9.329,9.329,0,0,1-3.058,2.309,9.707,9.707,0,0,1-7.207.433,9.293,9.293,0,0,1-3.309-1.925,9.728,9.728,0,0,1-3.253-6.646,10.093,10.093,0,0,1,.46-3.661,9.345,9.345,0,0,1,4.95-5.585,10.1,10.1,0,0,1,3.58-.9,9.927,9.927,0,0,1,3.694.491,9.281,9.281,0,0,1,3.325,1.908",
    transform: "translate(96.899 12.847)",
    fill: "#3b55ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24903",
    "data-name": "Path 24903",
    d: "M234.423,46.918l-15.015,3.749a25.493,25.493,0,0,1-1.434-8.018,17.5,17.5,0,0,1,.968-5.856,14.173,14.173,0,0,1,2.388-4.23,36.006,36.006,0,0,1,2.944-3.143q1.471-1.381,2.56-2.6a4.7,4.7,0,0,0,1.243-2.671,3.827,3.827,0,0,0-.281-1.887,3.955,3.955,0,0,0-1.406-1.75,6.067,6.067,0,0,0-2.7-1,10.658,10.658,0,0,0-4.136.347,30.668,30.668,0,0,0-3.726,1.235,42.456,42.456,0,0,0-4.376,2.037,45.846,45.846,0,0,0-4.364,2.647,26.5,26.5,0,0,0-3.7,3.024l-6.3-16.924q1.4-1.388,3.2-2.947a34.241,34.241,0,0,1,4.086-3,41.583,41.583,0,0,1,5.081-2.707,36.425,36.425,0,0,1,6.175-2.108,35.736,35.736,0,0,1,10.7-1.068,26.211,26.211,0,0,1,9.617,2.319,21.977,21.977,0,0,1,7.576,5.777,22.457,22.457,0,0,1,4.588,9.306,16.588,16.588,0,0,1,.493,7.074,13.048,13.048,0,0,1-2.018,4.961,18.69,18.69,0,0,1-3.487,3.8q-2.033,1.687-3.9,3.547a20.1,20.1,0,0,0-3.238,4.228,12.833,12.833,0,0,0-1.534,5.858m5.147,11.172a9.079,9.079,0,0,1,.155,3.83,10.073,10.073,0,0,1-1.284,3.459,9.76,9.76,0,0,1-2.456,2.737,9.2,9.2,0,0,1-3.413,1.631,9.315,9.315,0,0,1-3.827.175,9.7,9.7,0,0,1-6.19-3.716,9.31,9.31,0,0,1-1.641-3.459,9.738,9.738,0,0,1,1.074-7.322,10.092,10.092,0,0,1,2.448-2.759A9.1,9.1,0,0,1,227.893,51a9,9,0,0,1,3.786-.144,10.1,10.1,0,0,1,3.459,1.286,9.955,9.955,0,0,1,2.77,2.492,9.3,9.3,0,0,1,1.663,3.454",
    transform: "translate(114.181 0)",
    fill: "#3b55ce"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGraphic);
export default __webpack_public_path__ + "static/media/error-graphic.89a726bdb15a43405739ed65f76a19f1.svg";
export { ForwardRef as ReactComponent };